import { defineComponent as a, computed as o, openBlock as i, createElementBlock as r, createElementVNode as e, toDisplayString as c, createCommentVNode as _, normalizeStyle as f } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "a5699802-bd60-427f-a2bd-e6960363d7ed" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#a5699802-bd60-427f-a2bd-e6960363d7ed)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "m0 160 256-32 256 32v192l-256 32L0 352Z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 0h512v160H0Z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 352h512v160H0Z"
}, null, -1), x = { fill: "none" }, w = ["r"], N = /* @__PURE__ */ a({
  __name: "in-or",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(d) {
    const t = d, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (i(), r("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (i(), r("title", k, c(t.flagName), 1)) : _("", !0),
        p,
        v,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, h));
  }
});
export {
  N as default
};
//# sourceMappingURL=in-or-7a91cd54.js.map
